import styled from "@emotion/styled";
import { AnimatePresence, CustomValueType, motion } from "framer-motion";
import React from "react";
import { framerEasings, onIntentToDismissDown } from "../../../utils/framerUtils";

export default function DismissableMainLayoutOverlay(props: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  initialY?: string | number | CustomValueType | undefined;
}) {
  return (
    <AnimatePresence>
      {props.isOpen && (
        <Root
          initial={{ translateY: props.initialY ?? "110%", scale: 0.7 }}
          animate={{ translateY: 0, scale: 1 }}
          exit={{ translateY: props.initialY ?? "110%", opacity: 0, scale: 0.7 }}
          drag="y"
          transition={{ duration: 0.4, ease: framerEasings.custom }}
          dragConstraints={{ top: 0, bottom: 0 }}
          dragElastic={{ top: 0.1, bottom: 1 }}
          onPanEnd={onIntentToDismissDown(props.onClose)}
        >
          {props.children}
        </Root>
      )}
    </AnimatePresence>
  );
}

const Root = styled(motion.div)`
  margin: 8px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
`;
